///*
const STOREFRONT_API_ENDPOINT = 'https://the-daisy-refillery-is-coming-soon.myshopify.com/api/2026-01/graphql.json';
const STOREFRONT_API_TOKEN = '18906d61f28f0c49f4dd746ff8b69a80';
//*/


/* For DEV
const STOREFRONT_API_ENDPOINT = 'https://kc-dev-app-store.myshopify.com/api/2026-01/graphql.json';
const STOREFRONT_API_TOKEN = '5cc2e31c2719f27f6e6c22f09414808b';
//*/

const REFILLS_QUERY = `
  query RefillsCollectionProducts($handle: String!, $cursor: String) {
    collection(handle: $handle) {
      id
      title
      products(first: 50, after: $cursor) {
        edges {
          cursor
          node {
            id
            title
            handle
            vendor
            onlineStoreUrl
            featuredImage {
              url
              altText
            }
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
            metafields(identifiers: [
              { namespace: "product_details", key: "refill_type" },
              { namespace: "product_details", key: "refill_menu_categories" }
            ]) {
              key
              value
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`;

async function fetchRefillsPage(handle, cursor) {
  const res = await fetch(STOREFRONT_API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_API_TOKEN
    },
    body: JSON.stringify({
      query: REFILLS_QUERY,
      variables: { handle, cursor }
    })
  });

  if (!res.ok) {
    const text = await res.text();
    console.error('Storefront API HTTP error', res.status, res.statusText, text);
    throw new Error(`HTTP ${res.status} ${res.statusText}`);
  }

  const json = await res.json();

  if (json.errors) {
    console.error('Storefront API GraphQL errors:', json.errors);
    throw new Error(json.errors.map((e) => e.message).join(' | '));
  }

  const collection = json.data && json.data.collection;
  if (!collection) {
    console.error('No collection found in response:', json);
    throw new Error(`Collection with handle "${handle}" not found`);
  }

  return collection.products;
}

async function fetchAllRefills(handle) {
  let cursor = null;
  let hasNextPage = true;
  const allProducts = [];

  while (hasNextPage) {
    const productsConnection = await fetchRefillsPage(handle, cursor);
    const edges = productsConnection.edges || [];

    edges.forEach((edge) => {
      allProducts.push(edge.node);
    });

    const lastEdge = edges[edges.length - 1];
    cursor = lastEdge ? lastEdge.cursor : null;
    hasNextPage = productsConnection.pageInfo.hasNextPage;
  }

  return allProducts;
}

function getProductRefillData(product) {
  const meta = Array.isArray(product.metafields) ? product.metafields : [];
  let refillType = '';
  let refillCategories = [];

  meta.forEach((m) => {
    // Skip null/undefined entries defensively
    if (!m || typeof m.key !== 'string') return;

    if (m.key === 'refill_type') {
      refillType = m.value || '';
    } else if (m.key === 'refill_menu_categories') {
      try {
        // list metafield value is a JSON array string
        refillCategories = JSON.parse(m.value || '[]');
      } catch (_e) {
        refillCategories = [];
      }
    }
  });

  return { refillType, refillCategories };
}

// These must match my metafield *values* exactly.
//If I change the choices in product_details.refill_type or product_details.refill_menu_categories, update these arrays.

const REFILL_TYPES = ['Liquid', 'Powder', 'Unit'];

const CLEANING_CATEGORIES = [
  'All Purpose Cleaner',
  'Dish Soap',
  'Dishwasher',
  'Laundry Detergent'
];

const PERSONAL_CARE_CATEGORIES = [
  'Body Lotion',
  'Body Wash',
  'Carrier Oil',
  'Conditioner',
  'Dry Shampoo',
  'Hand Soap',
  'Oral Hygiene',
  'Shampoo',
  'Shaving',
  'Skincare'
];

const SPECIFIC_CATEGORIES = ['Baby', 'Pet', 'Other'];

function renderRefillSection(products, categories, sectionTitle, sectionId) {
  let sectionHtml = `
    <div class="menu_sections_container">
      <div id="${sectionId}" class="menu_section">
        <div class="menu_section_title"><h2>${sectionTitle}</h2></div>
  `;

  categories.forEach((category) => {
    REFILL_TYPES.forEach((type) => {
      const matchingProducts = products.filter((product) => {
        const { refillType, refillCategories } = getProductRefillData(product);
        return (
          refillType === type &&
          Array.isArray(refillCategories) &&
          refillCategories.includes(category)
        );
      });

      if (!matchingProducts.length) return;

      const vendorsMap = {};
      matchingProducts.forEach((product) => {
        const vendor = product.vendor || 'Unknown vendor';
        if (!vendorsMap[vendor]) {
          vendorsMap[vendor] = [];
        }
        vendorsMap[vendor].push(product);
      });

      const vendorNames = Object.keys(vendorsMap).sort((a, b) =>
        a.localeCompare(b)
      );

      const itemsHtml = vendorNames
        .map((vendor) => {
          const vendorProducts = vendorsMap[vendor];

          vendorProducts.sort((a, b) =>
            (a.title || '').localeCompare(b.title || '')
          );

          const productsHtml = vendorProducts
            .map((product) => {
              const price =
                product.priceRange && product.priceRange.minVariantPrice;
              const priceFormatted = price
                ? `${parseFloat(price.amount).toFixed(2)}`
                : '';

              const unitSuffix = type !== 'Unit' ? '/oz' : '';

              return `
                <article class="refill-product">
                  <a href="/products/${product.handle}">
                    ${escapeHtml(product.title)}
                  </a>
                  - $${priceFormatted}${unitSuffix}
                </article>
              `;
            })
            .join('');

          return `
            <div class="refill-vendor-group">
              <p class="refill-vendor-heading">${escapeHtml(vendor)}</p>
              ${productsHtml}
            </div>
          `;
        })
        .join('');

      sectionHtml += `
        <div class="product__accordion accordion accordion_green">
          <details>
            <summary>
              <div class="summary__title">
                <div class="accordion__title refill__title">
                  ${escapeHtml(category)} (${escapeHtml(type)})
                </div>
              </div>
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
              </svg>
            </summary>
            <div class="accordion__content">
              <div class="refill_list">
                ${itemsHtml}
              </div>
            </div>
          </details>
        </div>
      `;
    });
  });

  sectionHtml += `
      </div>
    </div>
  `;

  return sectionHtml;
}

function renderFullRefillMenu(allProducts) {
  let sidebarLinks = '';
  let sectionsHtml = '';

  // Cleaning
  const cleaningHtml = renderRefillSection(
    allProducts,
    CLEANING_CATEGORIES,
    'CLEANING',
    'cleaning_refills'
  );
  if (cleaningHtml.includes('product__accordion')) {
    sidebarLinks += `<p><a class="menu_link" href="#cleaning_refills">Cleaning</a></p>`;
    sectionsHtml += cleaningHtml;
  }

  // Personal Care
  const personalCareHtml = renderRefillSection(
    allProducts,
    PERSONAL_CARE_CATEGORIES,
    'PERSONAL CARE',
    'personal_care_refills'
  );
  if (personalCareHtml.includes('product__accordion')) {
    sidebarLinks += `<p><a class="menu_link" href="#personal_care_refills">Personal Care</a></p>`;
    sectionsHtml += personalCareHtml;
  }

  // Category Specific
  const specificHtml = renderRefillSection(
    allProducts,
    SPECIFIC_CATEGORIES,
    'CATEGORY SPECIFIC',
    'category_specific_refills'
  );
  if (specificHtml.includes('product__accordion')) {
    sidebarLinks += `<p><a class="menu_link" href="#category_specific_refills">Category Specific</a></p>`;
    sectionsHtml += specificHtml;
  }

  return `
    <div class="menu_main">
      <div class="menu_side">
        <div class="menu_side_container">
          <div class="menu_side_menu">
            <div class="menu_links">
              <p class="menu_link_title">Browse by Refill Type</p>
              ${sidebarLinks}
            </div>
          </div>
        </div>
      </div>
      <div class="menu_container">
        ${sectionsHtml}
      </div>
    </div>
  `;
}

function escapeHtml(str) {
  return String(str || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

document.addEventListener('DOMContentLoaded', async () => {
  const root = document.getElementById('refill-menu-root');
  if (!root) return;

  const handle = root.getAttribute('data-collection-handle') || 'refills';

  try {
    const allProducts = await fetchAllRefills(handle);

    if (!allProducts.length) {
      const rte = root.querySelector('.rte') || root;
      rte.innerHTML = '<p>No refills found.</p>';
      return;
    }

    allProducts.sort((a, b) => {
      const av = (a.vendor || '').localeCompare(b.vendor || '');
      if (av !== 0) return av;
      return (a.title || '').localeCompare(b.title || '');
    });

    const html = renderFullRefillMenu(allProducts);

    const rte = root.querySelector('.rte');
    if (rte) {
      rte.innerHTML = html;
    } else {
      root.innerHTML = html;
    }
  } catch (e) {
    console.error('Refill menu error:', e);
    const rte = root.querySelector('.rte') || root;
    rte.innerHTML = `
      <p>Failed to load refill menu.</p>
      <pre style="white-space: pre-wrap; font-size: 0.875rem;">${escapeHtml(
        e.message || String(e)
      )}</pre>
    `;
  }
});